import { createRequestTypes } from '../utils';

export const SAVE_RAWMAT_DOCUMENT = createRequestTypes('rawMatDocument/SAVE_RAWMAT_DOCUMENT');
export const RAWMAT_DOCUMENT_LIST = createRequestTypes('rawMatDocument/RAWMAT_DOCUMENT_LIST');
export const UPLOAD_RAWMAT_DOCUMENT = createRequestTypes('rawMatDocument/UPLOAD_RAWMAT_DOCUMENT');
export const RAWMAT_DOCUMENT_LIST_FOR_RAWMAT = createRequestTypes('rawMatDocument/RAWMAT_DOCUMENT_LIST_FOR_RAWMAT');
export const DELETE_RAWMAT_DOCUMENT = createRequestTypes('rawMatDocument/DELETE_RAWMAT_DOCUMENT');
